var trackingConfig = {
    ga4gid: 'G-R0J9TXG1E3',
    prefix: 'conversional',
    trackerName: 'conversionalTracker',
    ga4TrackerName: 'conversionalGA4Tracker',
    journeyId: null
};
export default trackingConfig;
